import axios from 'axios';
import constants from './constants';
import downloadFile from 'react-file-download';

const { API_BASE_URL } = constants;



class ApiHelper {

    /*
     *  GET 
     */

     getFromPost(headers, url, data)
     {
         return axios.post(API_BASE_URL + url, data, {headers: headers})
            .then( result => {
                return result.data;
            })
            .catch(error => {
                console.log(error);
                return null;
            });
     }

    getFile(headers, url, data, title) {
        let fileName = title;
  
        axios.post(API_BASE_URL + url, data, { headers: headers, responseType: 'blob' })
        .then(result => {
          downloadFile(result.data, fileName);
          return true;
        })
        .catch(error => {
          return false;
        });
    };

    getCustomerFilter(headers) {  
        return axios
            .get(API_BASE_URL + 'Filter/GetCustomerFilter',
                {
                    headers: headers
                })
            .then(result => {
                let list = result.data.filter(x => x.Value.length == 5 || x.Value.endsWith('-C')).map(x => {

                    return {
                        label: x.Label,
                        value: x.Value
                    }
                    
                }).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));

                return list;
            })
            .catch((e) => {
                console.log("catch", e);

                return e;
            });
    }

    getAllocationCustomerFilter(headers) {  
        return axios
            .get(API_BASE_URL + 'Allocation/GetCustomerFilter',
                {
                    headers: headers
                })
            .then(result => {
                let list = result.data.map(x => {

                    return {
                        label: x.Label,
                        value: x.Value
                    }
                    
                }).sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));

                return list;
            })
            .catch((e) => {
                console.log("catch", e);

                return e;
            });
    }

    getSelectedFilters(headers) {
        return axios
            .get(API_BASE_URL + 'Filter/GetSelectedFilters', { headers: headers })
            .then(result => {
                return result.data;
            }).catch((e) => {
                console.log("catch", e);
                return e;
            });
    }

}

export default new ApiHelper();